import { EcEnv } from '@castlery/config';
import { apiPlugin, storyblokInit } from '@storyblok/react/rsc';
import { components } from './lib';
import type { StoryblokClient, ISbStoriesParams } from '@storyblok/react';
import { SbService } from '@castlery/modules-cms-services';

export const getStoryblokApi = storyblokInit({
  accessToken: EcEnv.NEXT_PUBLIC_STORYBLOK_TOKEN,
  use: [apiPlugin],
  components,
  bridge: true,
  apiOptions: {},
}) as () => StoryblokClient;

export const sbApiClient = new SbService({
  client: getStoryblokApi(),
});

export type { StoryblokClient, ISbStoriesParams };
